module.exports = __webpack_public_path__ + "static/empathyMap-c3b132436000ba1f51ff93c727626587.jpg";